export default "__VITE_PUBLIC_ASSET__c2cff703__"